import { type Guard, type GuardStatus, useSettings } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useEffect, useState } from 'react';

export const useCustodialGuard: Guard = () => {
	const { areSettingsLoading, settings } = useSettings();
	const [status, setStatus] = useState<GuardStatus>('loading');
	const { replace } = useRouter();

	useEffect(() => {
		if (areSettingsLoading) return setStatus('loading');
		if (settings.isPoblanoEnabled) {
			return setStatus('denied');
		}

		return setStatus('allowed');
	}, [areSettingsLoading, setStatus, settings.isPoblanoEnabled]);

	return {
		onDenied: () => replace('/nc-wallet'),
		status: status
	};
};
